export default __webpack_public_path__ + "static/media/light.be0dc53f.png";